import { localStorageKey } from 'constants/values';

export const setLocalStorage = ({ authentication, users }) => {
  const byId = {
    [authentication.user]: users.byId[authentication.user],
  };
  const itemValue = JSON.stringify({
    authentication,
    users: {
      byId,
    },
  });

  try {
    localStorage.setItem(localStorageKey, itemValue);
  } catch (error) {
    console.log(`Local storage not set - ${error.message}`);
  }
};

export const setCurrentUser = currentUser => {
  const store = localStorage.getItem(localStorageKey);
  const localStore = store ? JSON.parse(store) : {};
  let readMessagesIds = localStore.readMessagesIds || [];
  const itemValue = JSON.stringify({
    currentUser,
    readMessagesIds,
  });
  localStorage.setItem(localStorageKey, itemValue);
};

export const readLocalStorage = () => {
  const itemValue = localStorage.getItem(localStorageKey);
  return itemValue ? JSON.parse(itemValue) : {};
};

export const getCurrentUser = () => {
  let localStore = readLocalStorage();
  return localStore.currentUser;
};

export const localReadMessagesIds = () => {
  let localStore = readLocalStorage();
  return localStore.readMessagesIds || [];
};

export const clearLocalStorage = () => {
  localStorage.removeItem(localStorageKey);
};
